import styled from 'styled-components';

import { size } from '../layout/helpers';
import { fontBold } from '../layout/font';

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Item = styled.li`
  display: flex;
  align-items: flex-start;

  & + & {
    margin-top: ${size(1)};
  }
`;

export const Label = styled.div`
  flex: 1 1 auto;
`;

export const Value = styled.div`
  ${fontBold};
  flex-shrink: 0;
  padding-left: ${size(2)};
`;
